import { useGetMainSearchQuery } from '@/app/(main)/search/hooks/useGetMainSearchQuery';
import { goToSearchDetails } from '@/app/(main)/search/utils/goToSearchDetailsPath';
import { SEARCH_CATEGORIES } from '@/consts/search-const';
import type { GlobalSearchCategory, GlobalSearchDirectoryItem } from '@/types/globalSearchApiTypes';
import { CategoryWrapper } from '../CategoryWrapper';
import { DirectoryItem } from '../DirectoryItem';

interface DirectoryCategoryProps {
  data: GlobalSearchCategory<GlobalSearchDirectoryItem>;
}

export const DirectoryCategory = ({ data }: DirectoryCategoryProps) => {
  const { search, directory } = useGetMainSearchQuery();

  return (
    <CategoryWrapper
      categoryName="Directory"
      itemsCount={data.count}
      redirectToDetails={goToSearchDetails({ category: SEARCH_CATEGORIES.DIRECTORY, searchQuery: search, directory })}
    >
      {data.results.map((item) => (
        <DirectoryItem key={item.email} item={item} />
      ))}
    </CategoryWrapper>
  );
};